/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBrandSupabase = createReactComponent("brand-supabase", "IconBrandSupabase", [
  ["path", { d: "M4 14h8v7l8 -11h-8v-7z", key: "svg-0" }]
]);

export { IconBrandSupabase as default };
//# sourceMappingURL=IconBrandSupabase.js.map
